/**
 * Created by Olexiy on 01.03.2017.
 */

(function($){
    $(document).ready(function() {

        function getNews(action,categoryId,amount) {
            var request_in_process;
            var news = [];

            function addCustomHover(elem) {
                var color = elem.attr('data-hover-cl');
                var initColor = elem.css('background-color');
                elem.on('mouseenter',function() {
                    elem.css('background-color',color);
                });
                elem.on('mouseleave',function() {
                    elem.css('background-color',initColor);
                });
             }

            function getPosts(from,count,elem) {
                request_in_process = true;
                $.ajax({
                    type: "GET",
                    url: window.location.href,
                    dataType: 'json',
                    data: ({
                        action: action,
                        from: from,
                        count: count,
                        categoryId: categoryId
                    }),
                    success: function(data) {
                        $.each(data.posts, function(key,value) {
                            news.push(value);
                            var index = news.length-1;
                            var cssClass = 'new-item-' + index;
                            var bgSrc = '';
                            var $html = '';

                            if(index%2 !== 0) {
                                cssClass += ' has-background-image';
                                bgSrc = value.new_img_src;
                            }
                            if(index%3 === 1 || index === 1) {
                                cssClass += ' center';
                            }
                            $html += '<li class="' + cssClass + '" style="background-image: url(' + bgSrc + ')">';
                            $html += '<a class="js-hover" data-hover-cl="' + value.category_color + '" href="' + value.guid + '">';
                            $html += '<div class="content">';
                            $html += '<h3>' + value.post_title + '</h3>';
                            $html += '<p class="date">' + value.new_date + '</p>';
                            if(value.new_short_description) {
                                $html += '<div class="description"><p>' + value.new_short_description + '</p></div>';
                            }
                            $html += '</div></a></li>';

                            $(elem).append($html);
                            addCustomHover($('.new-item-' + index).find('a'));
                        });
                        request_in_process = false;
                    }
                });
            }

            function loadNews() {
                getPosts(news.length,3,'.js-list-others');
            }

            if(amount < 15) {
                getPosts(0,14,'.js-list');
            } else {
                getPosts(0,12,'.js-list');
                getPosts(12,3,'.js-list-others');
            }

            $(window).scroll(function(){
                if($(window).scrollTop() >= $(document).height() - $(window).height() - $('.main-footer').height() && news.length < amount && !request_in_process){
                    loadNews();
                }
            });
        }

        if($('body').hasClass('page-template-template-news')) {
            getNews('loadPosts','',$('main').find('.category-description').attr('data-amount'));
        } else if($('main').hasClass('category-page')) {
            var $catDescription = $('main').find('.category-description');
            if($catDescription.hasClass('news-category')) {
                getNews('loadPosts', parseInt($catDescription.attr('data-category-id')),parseInt($catDescription.attr('data-amount')));
            } else {
                getNews('loadProjects',parseInt($catDescription.attr('data-category-id')),parseInt($catDescription.attr('data-amount')));
            }
        }

        // search results load more emulation
        function loadSearchResults() {
            var $searchResultsContainer = $('.js-search-results');
            var resultsArray = $($searchResultsContainer).find('article');
            var openedResults = 0;

            function openResults(from,qty) {
                for(var i=from; i<from+qty; i++) {
                    resultsArray.eq(i).show();
                }
                openedResults +=qty;
            }

            openResults(0,3);

            $(window).scroll(function(){
                if($(window).scrollTop() >= $(document).height() - $(window).height()){
                    openResults(openedResults,3);
                }
            });
        }

        if($('body').hasClass('search')) {
            loadSearchResults();
        }
    });
})(jQuery);
